import { AnyAction, Store } from 'redux'
import { persistStore } from 'redux-persist'

import createStore from './createStore'
import rootReducer from './rootReducer'
import { ReduxState } from './types'

const initializeAppStore = (initialState: ReduxState) => {
  const store: Store<ReduxState, AnyAction> = createStore({
    rootReducer,
    initialState,
  })

  const persistor = persistStore(store)

  return { store, persistor }
}

export default initializeAppStore
